import * as z from "zod";
import { PrintQueueStatusSchema } from "./watch-print-queue";

export const cancelPrintJobs = {
  name: "cancelPrintJobs" as const,
  input: z.object({ printJobs: z.array(z.string()) }),
  output: PrintQueueStatusSchema,
};

export type CancelPrintJobsInput = z.infer<typeof cancelPrintJobs.input>;
